import {Injectable}                      from '@angular/core';
import {Api}                             from '../api.service';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable}                      from 'rxjs/Observable';
import {Base, BaseInterface}             from '../api/bases/api.models';
import {Utils}                           from '../utils.service';
import {tap}                             from 'rxjs/operators';

interface GroupedBase {
    name: string;
    bases: BaseInterface[];
}


@Injectable()
class GroupedBasesResolver implements Resolve<any> {
    constructor(private api: Api, private utils: Utils) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return Observable.create((main) => {
            let grouped: GroupedBase[] = [];
            let hash: {[key: string]: GroupedBase} = {};

            this.api.bases().collection().subscribe((bases: BaseInterface[]) => {
                bases.forEach((base: BaseInterface) => {
                    const type = base.settings.baseType;

                    if (!hash[type]) {
                        hash[type] = {
                            name: type,
                            bases: []
                        };

                        switch (type) {
                            case Base.TYPE_CHATOMATIC:
                                hash[type].name = 'Chat-O-Matic Bases (Pokes)';
                                break;
                            case Base.TYPE_FLIRTMACHINE:
                                hash[type].name = 'FlirtMachine (Triggers)';
                                break;
                        }

                        grouped.push(hash[base.settings.baseType]);
                    }

                    hash[base.settings.baseType].bases.push(base);
                });

                grouped.forEach((grouped: GroupedBase) => this.utils.sortList(grouped.bases, 'name'));

                main.next(grouped);
                main.complete();
            });
        });
    }
}

@Injectable()
class BasesResolver implements Resolve<any> {
    constructor(private api: Api, private utils: Utils) {}

    resolve(route: ActivatedRouteSnapshot): Observable<BaseInterface[]> {
        const type: string = route.data['type'];

        return this.api.bases().collection(type).pipe(
            tap((bases: BaseInterface[]) => this.utils.sortList(bases, 'name'))
        );
    }
}

@Injectable()
class BaseResolver implements Resolve<any> {
    constructor(private api: Api) {}

    resolve(route: ActivatedRouteSnapshot): Observable<BaseInterface> {
        return this.api.bases().resource(route.params[route.data['baseRouteIdentifier']]);
    }
}

export {
    BasesResolver,
    BaseResolver,
    GroupedBasesResolver,
    GroupedBase
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/bases.resolver.ts